// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************************************************************/
/* ポップアップ位置は固定（位置はその都度決める） */
#popup	{
	position: absolute;
	z-index: 50;
	background-color: rgba( 255, 255, 255, 0.8 );
	padding: 10px;
	border: 1px solid #555;
	border-radius: 5px;
}

/******************************************************************************/
/* root要素 */
#popup div.root	{
	position: relative;
}

/******************************************************************************/
/* 閉じるボタン */
#popup div.root span.close	{
	position: absolute;
	top: 0;
	right: 0;
	border: 1px solid #555;
	border-radius: 3px;
	font-size: 1em;
	cursor: pointer;
}

/******************************************************************************/
/* 各見出し */
#popup div.root h1	{
	margin: 0;
	padding: 0;
	font-size: 1em;
}

/******************************************************************************/
/* 表組みにする定義 */
#popup div.root dl,
#popup div.root dl dt,
#popup div.root dl dd	{
	display: flex;
}
#popup div.root dl dt,
#popup div.root dl dd	{
	box-sizing: border-box;
	margin: 0;
	padding: 5px;
	border-bottom: 1px solid #ccc;
	flex-direction: column;
}

/******************************************************************************/
/* 幅と枠線指定 */
#popup div.root dl	{
	flex-wrap: wrap;
	width: 260px;
	border: 1px solid #ccc;
	border-bottom: none;
	margin: 5px 0;
}
#popup div.root dl dt	{
	width: 120px;
	border-right: 1px solid #ccc;
	background: #f5f5f5;
}
#popup div.root dl dd	{
	width: 140px;
	background: #fff;
}

/******************************************************************************/
/* 配置指定（数値は右寄せ） */
#popup div.root dl dd.lng,
#popup div.root dl dd.lat,
#popup div.root dl dd.elev,
#popup div.root dl dd.direction,
#popup div.root dl dd.incline,
#popup div.root dl dd.distance,
#popup div.root dl dd.total,
#popup div.root dl dd.angle	{
	text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Measure/popup.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E,4BAA4B;AAC5B;CACC,kBAAkB;CAClB,WAAW;CACX,4CAA4C;CAC5C,aAAa;CACb,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA,+EAA+E;AAC/E,WAAW;AACX;CACC,kBAAkB;AACnB;;AAEA,+EAA+E;AAC/E,WAAW;AACX;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,eAAe;AAChB;;AAEA,+EAA+E;AAC/E,SAAS;AACT;CACC,SAAS;CACT,UAAU;CACV,cAAc;AACf;;AAEA,+EAA+E;AAC/E,aAAa;AACb;;;CAGC,aAAa;AACd;AACA;;CAEC,sBAAsB;CACtB,SAAS;CACT,YAAY;CACZ,6BAA6B;CAC7B,sBAAsB;AACvB;;AAEA,+EAA+E;AAC/E,WAAW;AACX;CACC,eAAe;CACf,YAAY;CACZ,sBAAsB;CACtB,mBAAmB;CACnB,aAAa;AACd;AACA;CACC,YAAY;CACZ,4BAA4B;CAC5B,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA,+EAA+E;AAC/E,iBAAiB;AACjB;;;;;;;;CAQC,iBAAiB;AAClB","sourcesContent":["/******************************************************************************/\n/* ポップアップ位置は固定（位置はその都度決める） */\n#popup\t{\n\tposition: absolute;\n\tz-index: 50;\n\tbackground-color: rgba( 255, 255, 255, 0.8 );\n\tpadding: 10px;\n\tborder: 1px solid #555;\n\tborder-radius: 5px;\n}\n\n/******************************************************************************/\n/* root要素 */\n#popup div.root\t{\n\tposition: relative;\n}\n\n/******************************************************************************/\n/* 閉じるボタン */\n#popup div.root span.close\t{\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tborder: 1px solid #555;\n\tborder-radius: 3px;\n\tfont-size: 1em;\n\tcursor: pointer;\n}\n\n/******************************************************************************/\n/* 各見出し */\n#popup div.root h1\t{\n\tmargin: 0;\n\tpadding: 0;\n\tfont-size: 1em;\n}\n\n/******************************************************************************/\n/* 表組みにする定義 */\n#popup div.root dl,\n#popup div.root dl dt,\n#popup div.root dl dd\t{\n\tdisplay: flex;\n}\n#popup div.root dl dt,\n#popup div.root dl dd\t{\n\tbox-sizing: border-box;\n\tmargin: 0;\n\tpadding: 5px;\n\tborder-bottom: 1px solid #ccc;\n\tflex-direction: column;\n}\n\n/******************************************************************************/\n/* 幅と枠線指定 */\n#popup div.root dl\t{\n\tflex-wrap: wrap;\n\twidth: 260px;\n\tborder: 1px solid #ccc;\n\tborder-bottom: none;\n\tmargin: 5px 0;\n}\n#popup div.root dl dt\t{\n\twidth: 120px;\n\tborder-right: 1px solid #ccc;\n\tbackground: #f5f5f5;\n}\n#popup div.root dl dd\t{\n\twidth: 140px;\n\tbackground: #fff;\n}\n\n/******************************************************************************/\n/* 配置指定（数値は右寄せ） */\n#popup div.root dl dd.lng,\n#popup div.root dl dd.lat,\n#popup div.root dl dd.elev,\n#popup div.root dl dd.direction,\n#popup div.root dl dd.incline,\n#popup div.root dl dd.distance,\n#popup div.root dl dd.total,\n#popup div.root dl dd.angle\t{\n\ttext-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
